import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Logo";

const LEGAL_LINKS = [
  { to: "/privacy", label: "Privacy Policy" },
  { to: "/terms", label: "Terms of Service" },
  { to: "/subscription-terms", label: "Subscription Terms" },
  { to: "/eula", label: "EULA" },
  { to: "/disclaimer", label: "Disclaimer & Safety" },
  { to: "/support", label: "Support" },
];

export function LegalLayout({ title, updated, intro, children }) {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="min-h-screen bg-cream text-ink font-sans">
      <header className="sticky top-0 z-40 backdrop-blur-md bg-cream/80 border-b border-cardborder">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" data-testid="legal-logo"><Logo /></Link>
          <Link to="/" data-testid="legal-home-link" className="inline-flex items-center gap-1.5 text-sm font-semibold text-ink hover:text-sage-hover transition-colors">
            <ArrowLeft className="h-4 w-4" /> Back to home
          </Link>
        </div>
      </header>

      <article className="max-w-3xl mx-auto px-6 py-14 lg:py-20">
        <p className="text-xs font-mono uppercase tracking-[0.15em] text-sage-hover">Next Time</p>
        <h1 className="mt-3 font-serif font-bold tracking-tight text-4xl sm:text-5xl text-ink leading-tight">{title}</h1>
        {updated && <p className="mt-4 text-sm font-mono text-ink-muted">Last updated: {updated}</p>}
        {intro && <P className="mt-6 text-lg">{intro}</P>}
        <div className="mt-8">{children}</div>
      </article>

      <footer className="border-t border-cardborder bg-cream-alt">
        <div className="max-w-3xl mx-auto px-6 py-10">
          <Logo />
          <nav className="mt-5 flex flex-wrap gap-x-6 gap-y-2">
            {LEGAL_LINKS.map((l) => (
              <Link key={l.to} to={l.to} className="text-sm text-ink-muted hover:text-ink transition-colors">{l.label}</Link>
            ))}
          </nav>
          <p className="mt-5 text-xs text-ink-muted">© {new Date().getFullYear()} Next Time. A practice tool, not a substitute for professional care. Questions? <a href="mailto:decompresspause@gmail.com" className="underline hover:text-ink">decompresspause@gmail.com</a></p>
        </div>
      </footer>
    </div>
  );
}

export function H2({ children }) {
  return <h2 className="font-serif text-2xl text-ink mt-10 mb-3">{children}</h2>;
}
export function H3({ children }) {
  return <h3 className="font-serif text-lg text-ink mt-6 mb-2">{children}</h3>;
}
export function P({ children, className = "" }) {
  return <p className={`text-ink-muted leading-relaxed mb-4 ${className}`}>{children}</p>;
}
export function UL({ children }) {
  return <ul className="list-disc pl-6 space-y-2 text-ink-muted leading-relaxed mb-4">{children}</ul>;
}
export function LI({ children }) {
  return <li>{children}</li>;
}
